import {getConvertUtc} from '~/utils/date'
const blockColor = '#fc4132'
const createInOutBoundSeries = (_this, top10Color, list) => {
  const blockText = _this.$t('an.block')
  const inFields = ['in_tcp', 'in_udp', 'in_icmp', 'in_etc', 'in_total_block']
  const outFields = ['out_tcp', 'out_udp', 'out_icmp', 'out_etc', 'out_total_block']
  const names = ['TCP', 'UDP', 'ICMP', 'ETC', blockText]
  const series = []
  /*  x축 time값 */
  _this.xAxisTime = []
  let inMax = 1

  for (let i = 0; i < inFields.length; i++) {
    const inFieldsName = inFields[i]
    const outFieldsName = outFields[i]
    const inFieldsData = []
    const outFieldsData = []
    const tmpLstMax = []
    for (let j = 0; j < list.length; j++) {
      const listItem = list[j]
      const timeValue = new Date(listItem.time)
      const timeValueUtc = getConvertUtc(timeValue)
      // 시간축 값 저장
      if (i === 0) {
        /* formatter 에서 moment 사용안됨 */
        _this.xAxisTime.push(timeValueUtc)
      }
      inFieldsData.push(listItem[inFieldsName])
      outFieldsData.push(-(listItem[outFieldsName]))
      tmpLstMax.push(listItem[inFieldsName])
      tmpLstMax.push(listItem[outFieldsName])
    }
    inMax = Math.max(inMax, ...tmpLstMax)

    let color = top10Color[i]
    if (i === inFields.length - 1) {
      color = blockColor
    }

    const inSeriesItem = {
      id: inFieldsName,
      name: names[i],
      data: inFieldsData,
      type: 'line',
      areaStyle: {},
      color: color
    }
    const outSeriesItem = {
      id: outFieldsName,
      name: names[i],
      data: outFieldsData,
      type: 'line',
      areaStyle: {},
      color: color
    }
    series.push(inSeriesItem)
    series.push(outSeriesItem)
  }
  /* Y축 입력/출력 min, max값 */
  _this.yInMax = inMax
  _this.yInMin = -(inMax)

  const cpuUsageData = []
  const diskUsageData = []
  for (let i = 0; i < list.length; i++) {
    const listItem = list[i]
    cpuUsageData.push(listItem.cpu_usage)
    diskUsageData.push(listItem.disk_usage)
  }
  const cpuUsageSeries = {
    id: 'cpu_usage',
    name: 'CPU',
    data: cpuUsageData,
    type: 'line',
    color: top10Color[inFields.length],
    yAxisIndex: 2
  }
  const diskUsageSeries = {
    id: 'disk_usage',
    name: 'DISK',
    data: diskUsageData,
    type: 'line',
    color: top10Color[inFields.length + 1],
    yAxisIndex: 2
  }
  series.push(cpuUsageSeries)
  series.push(diskUsageSeries)
  return _.cloneDeep(series)
}

const setInOutBoundLegendVisible = (_this) => {
  const inId = String(_this.userOptions.id)
  const splitNames = inId.split('_')
  const splitName = splitNames[splitNames.length - 1]
  let inSeriesItem = null
  let outSeriesItem = null
  const series = _this.chart.series
  for (let i = 0; i < series.length; i++) {
    const seriesItem = series[i]
    if (String(seriesItem.userOptions.id) === inId) {
      inSeriesItem = seriesItem
    } else if (String(seriesItem.userOptions.id).indexOf('out_') > -1 && String(seriesItem.userOptions.id).indexOf(splitName) > -1) {
      outSeriesItem = seriesItem
    }
  }
  if (inSeriesItem && outSeriesItem) {
    inSeriesItem.visible === true ? outSeriesItem.hide() : outSeriesItem.show()
  }
}

const createInOutputSeries = (_this, top10Color, list) => {
  const blockText = _this.$t('an.block')
  const inFields = ['input_tcp', 'input_udp', 'input_icmp', 'input_etc']
  const outFields = ['output_tcp', 'output_udp', 'output_icmp', 'output_etc']
  const names = ['TCP', 'UDP', 'ICMP', 'ETC']
  const series = []
  _this.xAxisTime = []
  let _max = 1
  for (let i = 0; i < inFields.length; i++) {
    const inFieldsName = inFields[i]
    const outFieldsName = outFields[i]
    const inFieldsData = []
    const outFieldsData = []
    const tmpLstMax = []
    for (let j = 0; j < list.length; j++) {
      const listItem = list[j]
      const timeValue = new Date(listItem.time)
      const timeValueUtc = getConvertUtc(timeValue)
      // 시간축 값 저장
      if (i === 0) {
        /* formatter 에서 moment 사용안됨 */
        _this.xAxisTime.push(timeValueUtc)
      }
      inFieldsData.push(listItem[inFieldsName])
      outFieldsData.push(-(listItem[outFieldsName]))
      tmpLstMax.push(listItem[inFieldsName])
      tmpLstMax.push(listItem[outFieldsName])
    }
    /* Y축 입력/출력 max값 구하기 */
    _max = Math.max(_max, ...tmpLstMax)
    const color = top10Color[i]
    const inSeriesItem = {
      id: inFieldsName,
      name: names[i],
      data: inFieldsData,
      type: 'line',
      areaStyle: {},
      color: color
    }
    const outSeriesItem = {
      id: outFieldsName,
      name: names[i],
      data: outFieldsData,
      type: 'line',
      areaStyle: {},
      color: color
    }
    series.push(inSeriesItem)
    series.push(outSeriesItem)
  }
  _this.yInMax = _max
  _this.yInMin = -_max
  const blockFields = ['block_tcp', 'block_udp', 'block_icmp', 'block_etc']
  let count = 0
  for (let i = 0; i < blockFields.length; i++) {
    const blockFieldsName = blockFields[i]
    const blockFieldsData = []
    for (let j = 0; j < list.length; j++) {
      const listItem = list[j]

      blockFieldsData.push(listItem[blockFieldsName])
    }
    const blockSeriesItem = {
      id: blockFieldsName,
      name: blockText,
      data: blockFieldsData,
      type: 'line',
      areaStyle: {},
      color: blockColor
    }
    series.push(blockSeriesItem)
    count = count + 1
  }
  const cpuUsageData = []
  const diskUsageData = []
  for (let i = 0; i < list.length; i++) {
    const listItem = list[i]
    cpuUsageData.push(listItem.cpu_usage)
    diskUsageData.push(listItem.disk_usage)
  }
  const cpuUsageSeries = {
    id: 'cpu_usage',
    name: 'CPU',
    data: cpuUsageData,
    type: 'line',
    color: top10Color[inFields.length],
    yAxisIndex: 2
  }
  const diskUsageSeries = {
    id: 'disk_usage',
    name: 'DISK',
    data: diskUsageData,
    type: 'line',
    color: top10Color[inFields.length + 1],
    yAxisIndex: 2
  }
  series.push(cpuUsageSeries)
  series.push(diskUsageSeries)
  return series
}

const setInOutputLegendVisible = (_this) => {
  const series = _this.chart.series
  const inId = String(_this.userOptions.id)
  if (inId.indexOf('block_') > -1) {
    let currentBlockSeriesItem = null
    const blockSeriesItems = []
    for (let i = 0; i < series.length; i++) {
      const seriesItem = series[i]
      if (String(seriesItem.userOptions.id) === inId) {
        currentBlockSeriesItem = seriesItem
      }
      if (String(seriesItem.userOptions.id).indexOf('block') > -1 && String(seriesItem.userOptions.id) !== inId) {
        blockSeriesItems.push(seriesItem)
      }
    }
    if (currentBlockSeriesItem && blockSeriesItems.length > 0) {
      for (let i = 0; i < blockSeriesItems.length; i++) {
        const blockSeriesItem = blockSeriesItems[i]
        currentBlockSeriesItem.visible === true ? blockSeriesItem.hide() : blockSeriesItem.show()
      }
    }
  } else {
    const splitNames = inId.split('_')
    const splitName = splitNames[splitNames.length - 1]
    let inSeriesItem = null
    let outSeriesItem = null
    for (let i = 0; i < series.length; i++) {
      const seriesItem = series[i]
      if (String(seriesItem.userOptions.id) === inId) {
        inSeriesItem = seriesItem
      } else if (String(seriesItem.userOptions.id).indexOf('output_') > -1 && String(seriesItem.userOptions.id).indexOf(splitName) > -1) {
        outSeriesItem = seriesItem
      }
      if (inSeriesItem && outSeriesItem) {
        inSeriesItem.visible === true ? outSeriesItem.hide() : outSeriesItem.show()
      }
    }
  }
}

const createItemKeys = (item) => {
  const unique = []
  for (const key in item) {
    if (!(key === 'time' || key === 'displayTime' || key === 'timeUnit')) {
      unique.push(key)
    }
  }
  return unique
}

const createSeries = (_this, top10Color, list) => {
  const series = []
  _this.xAxisTime = []

  if (list.length === 0) return series

  const keys = createItemKeys(list[0])
  const tmpLstMax = []
  for (let i = 0; i < keys.length; i++) {
    const seriesData = []
    const key = keys[i]
    for (let j = 0; j < list.length; j++) {
      const listItem = list[j]
      const timeValue = new Date(listItem.time)
      const timeValueUtc = getConvertUtc(timeValue)

      // 시간축 값 저장
      if (i === 0) {
        /* formatter 에서 moment 사용안됨 */
        _this.xAxisTime.push(timeValueUtc)
      }
      seriesData.push(listItem[key])
      tmpLstMax.push(listItem[key])
    }
    const seriesItem = {
      id: key,
      name: key,
      data: seriesData,
      type: 'line',
      color: top10Color[i]
    }
    series.push(seriesItem)
  }
  const yMax = Math.max(...tmpLstMax)
  _this.yInMax = yMax
  _this.yInMin = 0

  return series
}

const setProtocolLegendVisible = () => {
}

const setServiceLegendVisible = () => {
}
const createSimpleKeyValue = (item) => {
  const keys = []
  const values = []
  for (const key in item) {
    if (item.hasOwnProperty(key)) {
      keys.push(key)
      values.push(item[key])
    }
  }
  const key = keys[0]
  const value = values[0]
  return {
    key: key,
    value: value
  }
}
const createRowItems = (result) => {
  const data = []
  if (result.length > 0) {
    for (let i = 0; i < result.length; i++) {
      const resultItems = result[i]
      const rowItem = {}
      for (let j = 0; j < resultItems.length; j++) {
        const item = resultItems[j]
        const keyValue = createSimpleKeyValue(item)
        rowItem['' + keyValue.key] = keyValue.value
      }
      data.push(rowItem)
    }
  }
  return data
}
const createData = (result) => {
  const list = createRowItems(result)
  return list
}
const createDynamicColumnsInfo = (result) => {
  const keys = []
  const item = result[0]
  for (const key in item) {
    if (item.hasOwnProperty(key)) {
      keys.push(key)
    }
  }
  return keys
}

const createQosSeries = (obj, type, top10Color, list) => {
  const series = []
  obj.xAxisTime = []

  if (list.length > 0) {
    const totalPacketData = []
    const totalByteData = []
    const allowPacketData = []
    const allowByteData = []
    const overPacketData = []
    const overByteData = []
    for (let i = 0; i < list.length; i++) {
      const listItem = list[i]
      const timeValue = new Date(listItem.time)
      const timeValueUtc = getConvertUtc(timeValue)
      obj.xAxisTime.push(timeValueUtc)

      totalPacketData.push(listItem.total_packets)
      totalByteData.push(listItem.total_bytes)
      allowPacketData.push(listItem.allow_packets)
      allowByteData.push(listItem.allow_bytes)
      overPacketData.push(listItem.over_packets)
      overByteData.push(listItem.over_bytes)
    }
    if (type === 'packets') {
      const totalPacketSeries = {
        id: 'total_packets',
        type: 'line',
        name: obj.$t('cmn.totalCountSimple') + ' ' + obj.$t('an.packets'),
        valueYField: 'total_packets',
        data: totalPacketData
      }
      series.push(totalPacketSeries)

      const allowPacketSeries = {
        id: 'allow_packets',
        type: 'line',
        name: obj.$tc('cmn.defense', 0) + ' ' + obj.$t('an.packets'),
        valueYField: 'allow_packets',
        data: allowPacketData
      }
      series.push(allowPacketSeries)

      const overPacketSeries = {
        id: 'over_packets',
        type: 'line',
        name: obj.$t('an.overPackets'),
        valueYField: 'over_packets',
        data: overPacketData
      }
      series.push(overPacketSeries)
    } else {
      const totalByteSeries = {
        id: 'total_bytes',
        type: 'line',
        name: obj.$t('cmn.totalCountSimple') + ' ' + obj.$t('an.bytes'),
        valueYField: 'total_bytes',
        data: totalByteData
      }
      series.push(totalByteSeries)

      const allowByteSeries = {
        id: 'allow_bytes',
        type: 'line',
        name: obj.$tc('cmn.defense', 0) + ' ' + obj.$t('an.bytes'),
        alueYField: 'allow_bytes',
        data: allowByteData
      }
      series.push(allowByteSeries)

      const overByteSeries = {
        id: 'over_bytes',
        type: 'line',
        name: obj.$t('an.over') + ' ' + obj.$t('an.bytes'),
        valueYField: 'over_bytes',
        data: overByteData
      }
      series.push(overByteSeries)
    }
  }
  obj.yInMax = void 0
  obj.yInMin = void 0
  return series
}

const createDisplayTime = (list, dateValue) => {
  for (let i = 0; i < list.length; i++) {
    const listItem = list[i]
    if (dateValue === 'month') {
      listItem.displayTime = String(listItem.time).substring(0, 7)
    } else if (dateValue === 'day') {
      listItem.displayTime = String(listItem.time).substring(0, 10)
    } else if (dateValue === 'hour') {
      listItem.displayTime = String(listItem.time).substring(0, 13)
    } else if (dateValue === 'min') {
      listItem.displayTime = String(listItem.time).substring(0, 16)
    }
  }
}

export {
  createInOutBoundSeries,
  setInOutBoundLegendVisible,
  createInOutputSeries,
  setInOutputLegendVisible,
  createSeries,
  setProtocolLegendVisible,
  setServiceLegendVisible,
  createData,
  createDynamicColumnsInfo,
  createQosSeries,
  createDisplayTime
}
